import z from "zod";

const translationPath =
  "page.4uBus.integrationRule.integrationRuleIService.errors.";

const integrationDirectionTypeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "integration_direction_type" },
);

const iServiceSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "i_service" },
);

export const integrationRuleIServiceSchema = z.object({
  id: z.string().optional(),
  integrationDirectionType: integrationDirectionTypeSchema,
  iService: iServiceSchema,
});

export type TIntegrationRuleIServiceForm = z.infer<
  typeof integrationRuleIServiceSchema
>;
